"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppName = void 0;
const types_1 = require("../tracking/types");
/**
 * Gets the adtech application name
 *
 * @param config - the AdSDK configuration
 *
 * @returns the adtech application to be served
 */
const getAppName = ({ adUnitClient, adUnitProduct, }) => {
    if (adUnitProduct === types_1.AdtechProduct.WebMobile &&
        adUnitClient === types_1.AdtechClient.Transfer) {
        return types_1.AdtechApplication.mobileWeb;
    }
    return types_1.AdtechApplication.desktopWallpaper;
};
exports.getAppName = getAppName;
//# sourceMappingURL=get-application-name.js.map